import { render, staticRenderFns } from "./ClassroomEdit.vue?vue&type=template&id=318525be&"
import script from "./ClassroomEdit.vue?vue&type=script&lang=js&"
export * from "./ClassroomEdit.vue?vue&type=script&lang=js&"
import style0 from "./ClassroomEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports